module.exports = __webpack_public_path__ + "img/slovenia.cab53f91.svg";